// @vendors
const Immutable = require('immutable');
const trim = require('lodash/string/trim');
const map = require('lodash/collection/map');
const get = require('lodash/object/get');

// @constants
const actionTypes = require('constants/actionTypes');

const INITIAL_STATE = Immutable.fromJS({
    isFetching: false,
    isFetched: false,
    displayDisclaimerModal: false,
    canContinueOperation: false,
    error: '',
    isinId: '',
    marketId: undefined,
    optionalParams: {
        feeNumbers: undefined,
        eventCode: undefined,
        valueCode: undefined
    },
    operationCode: '',
    disclaimers: Immutable.fromJS([])
});

function buildDisclaimer(disclaimer) {
    return {
        id: trim(get(disclaimer, 'id')),
        description: trim(get(disclaimer, 'description')),
        phrase: trim(get(disclaimer, 'phrase'))
    };
}

function successFetch(immState, response) {
    const disclaimers = map(response.disclaimer, buildDisclaimer);
    const mustDisplayModal = (disclaimers.length > 0) && !response.disableUsPersonModal;

    return immState.merge({
        isFetching: false,
        isFetched: true,
        displayDisclaimerModal: mustDisplayModal,
        canContinueOperation: !mustDisplayModal,
        operationCode: trim(response.operationCode),
        disclaimers: Immutable.fromJS(disclaimers)
    });
}

function fetching(immState, payload) {
    const marketId = get(payload, 'marketId');
    const optionalParams = get(payload, 'optionalParams') || {};

    return immState.merge({
        isFetching: true,
        isinId: trim(get(payload, 'isinId')),
        marketId: marketId == null ? undefined : trim(marketId),
        optionalParams: Immutable.fromJS(optionalParams)
    });
}

function brokerMiFIDUSPersonReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case actionTypes.BROKER_MIFID_US_PERSON_FETCHING:
            return fetching(state, action.payload);
        case actionTypes.BROKER_MIFID_US_PERSON_FETCHING_SUCCESS:
            return successFetch(state, action.payload.response);
        case actionTypes.BROKER_MIFID_US_PERSON_FETCHING_ERROR:
            return state.merge({
                isFetching: false,
                isFetched: true,
                error: trim(action.payload.error)
            });
        case actionTypes.BROKER_MIFID_US_PERSON_RESET:
            return INITIAL_STATE;
        default:
            return state;
    }
}

module.exports = brokerMiFIDUSPersonReducer;
